import { AnimatePresence, motion } from 'framer-motion'

import type { Settings } from 'modules/settings/lib/settings'

import Title from './Title'
import { F0Box, F0Card } from '@factorialco/f0-react'
import { Warning } from '@factorialco/f0-react/icons/app'
import i18n from 'modules/core/lib/i18n'

interface SectionProps {
  settings?: Settings
}
const Section = ({ settings }: SectionProps) => {
  const visibleSettings = settings?.children.filter(
    (child) => ('hidden' in child && !child.hidden) || !('hidden' in child)
  )
  if (!visibleSettings?.length || !settings) return null

  return (
    <F0Box display="flex" flexDirection="column" gap="2xl" paddingX="4xl" paddingY="xl">
      <Title title={settings.title} icon={settings.icon} />
      <F0Box
        display="grid"
        columns="1"
        gap="lg"
        sm={{
          columns: '2',
        }}
        md={{
          columns: '2',
        }}
        lg={{
          columns: '3',
        }}
        xl={{
          columns: '6',
        }}
      >
        {visibleSettings.map((setting) => (
          <AnimatePresence key={setting.id}>
            <motion.div
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              layout
              data-intercom-target={`settings-${setting.id}`}
            >
              <F0Card
                avatar={{
                  type: 'icon',
                  icon: setting.icon,
                }}
                title={setting.title}
                description={setting.description}
                fullHeight
                link={setting.url}
                metadata={
                  'missingInfo' in setting && setting.missingInfo
                    ? [
                        {
                          icon: Warning,
                          property: {
                            type: 'text',
                            value: i18n.t('common.information_missing'),
                            label: i18n.t('common.warning'),
                          },
                        },
                      ]
                    : undefined
                }
              />
            </motion.div>
          </AnimatePresence>
        ))}
      </F0Box>
    </F0Box>
  )
}

export default Section
